import { memo } from "react";

import { Icon } from "@chakra-ui/react";
import { Select, chakraComponents, createFilter } from "chakra-react-select";

import ShevronDownIcon from "@/assets/svg/shevron-down.svg";
import customSelectStyle from "@/styles/customTheme/selectCustomStyles";

export const DropdownIndicator = (props) => {
  return (
    <chakraComponents.DropdownIndicator {...props} padding="0">
      <Icon as={ShevronDownIcon} w={"18px"} h={"18px"} />
    </chakraComponents.DropdownIndicator>
  );
};

export const CustomOption = ({ children, ...props }) => {
  const { ...rest } = props.innerProps;
  const newProps = { ...props, innerProps: rest };
  return (
    <chakraComponents.Option {...newProps}>{children}</chakraComponents.Option>
  );
};

function SelectDefault(props) {
  return (
    <Select
      value={props.value}
      onMenuOpen={false}
      components={{
        DropdownIndicator,
        Option: CustomOption,
      }}
      filterOption={createFilter({ ignoreAccents: false })}
      chakraStyles={customSelectStyle(props?.customSelectStyle || props)}
      {...props}
    />
  );
}

export default memo(SelectDefault);
